module.exports = __webpack_public_path__ + "static/media/9.5f33ee04.jpg";